module.exports = [{"componentChunkName":"page-component---src-pages-detail-js","jsonName":"detail.json","path":"/detail/"},{"componentChunkName":"page-component---src-pages-index-js","jsonName":"index.json","path":"/"}]


//////////////////
// WEBPACK FOOTER
// ./.cache/pages.json
// module id = ./.cache/pages.json
// module chunks = 15178676390636814000